var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "variationPrices bkr-cc",
      class: [
        { furniture: _vm.ourFurniture, "has-crossprice": _vm.hasCrossPrice },
      ],
    },
    [
      _vm.savePercent > 0
        ? _c("span", { staticClass: "percent" }, [
            _vm._v(
              "\n        Sie sparen " +
                _vm._s(_vm._f("numberFormat")(_vm.savePercent, 2, ",")) +
                "%\n    "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showCrossPrice && _vm.hasCrossPrice
        ? _c(
            "span",
            {
              staticClass: "text-muted",
              class: { "is-special-offer": _vm.hasSpecialOffer },
              attrs: { id: "itemmrp" },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$translate("biokinderDesign::Template.itemInstedOf")
                  ) +
                  "\n        "
              ),
              _c("del", { staticClass: "small text-appearance" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm._f("itemCrossPrice")(
                        _vm.currentVariation.prices.rrp.unitPrice.formatted
                      )
                    ) +
                    "\n        "
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "singleprice", class: { colorred: _vm.hasCrossPrice } },
        [
          _c(
            "span",
            [
              _vm.showDynamicPrice
                ? [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$translate(
                            "Ceres::Template.dynamicVariationPrice",
                            {
                              price: _vm.$options.filters.currency(
                                _vm.variationTotalPrice,
                                _vm.currentVariation.prices.default.currency
                              ),
                            }
                          )
                        ) +
                        "\n            "
                    ),
                  ]
                : [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm._f("currency")(
                            _vm.variationTotalPrice,
                            _vm.currentVariation.prices.default.currency
                          )
                        ) +
                        "\n            "
                    ),
                  ],
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "clearer" }),
      _vm._v(" "),
      _vm.currentVariation.unit &&
      _vm.currentVariation.variation.mayShowUnitPrice
        ? _c(
            "div",
            {
              staticClass: "base-price text-muted my-1",
              class: {
                "is-single-piece":
                  _vm.currentVariation.unit &&
                  _vm.currentVariation.unit.content === 1 &&
                  _vm.currentVariation.unit.unitOfMeasurement === "C62",
              },
            },
            [
              _vm._v(
                "\n\n        " +
                  _vm._s(_vm.$translate("Ceres::Template.singleItemContent")) +
                  ":\n        "
              ),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm._f("numberFormat")(_vm.currentVariation.unit.content)
                  ) + " "
                ),
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.currentVariation.unit.names.name)),
              ]),
              _vm._v("\n         | \n        "),
              _c("span", { staticClass: "base-price-value" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm._f("specialOffer")(
                        _vm.variationGraduatedPrice.basePrice,
                        _vm.currentVariation.prices,
                        "basePrice"
                      )
                    ) +
                    "\n        "
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "shippinginfo" },
        [
          _c(
            "span",
            {
              attrs: { tabindex: "0" },
              on: {
                click: _vm.toggleDetails,
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.toggleDetails.apply(null, arguments)
                },
              },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$translate("Ceres::Template.singleItemInclVAT")) +
                  "\n            "
              ),
              _c(
                "svg",
                {
                  staticClass: "css-i6dzq1",
                  attrs: {
                    viewBox: "0 0 24 24",
                    width: "14",
                    height: "14",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    fill: "none",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                },
                [
                  _c("circle", { attrs: { cx: "12", cy: "12", r: "10" } }),
                  _vm._v(" "),
                  _c("line", {
                    attrs: { x1: "12", y1: "16", x2: "12", y2: "12" },
                  }),
                  _vm._v(" "),
                  _c("line", {
                    attrs: { x1: "12", y1: "8", x2: "12.01", y2: "8" },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("transition", { attrs: { name: "slide" } }, [
            _vm.showDetails
              ? _c(
                  "div",
                  { staticClass: "details" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$translate("Ceres::Template.singleItemExclusive")
                        ) +
                        " "
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "openPorto",
                        attrs: {
                          "data-toggle": "modal",
                          href: "#shippingscosts",
                          title: _vm.$translate(
                            "Ceres::Template.singleItemShippingCosts"
                          ),
                        },
                      },
                      [
                        _vm._v("CO"),
                        _c("sub", [_vm._v("2")]),
                        _vm._v(" neutraler & fairer Versand"),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._t("additional-content-after-vat"),
                    _vm._v(" "),
                    _vm.showCrossPrice && _vm.hasCrossPrice
                      ? _c("span", [
                          _c("br"),
                          _vm._v(
                            "Zuletzt niedrigster Preis " +
                              _vm._s(
                                _vm.currentVariation.prices.default.lowestPrice
                                  .formatted
                              ) +
                              "\n                "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasFixedPrice
                      ? _c("span", [
                          _c("br"),
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "biokinderDesign::Template.fixedPrice"
                              )
                            ) + "\n                "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }